export default __webpack_public_path__ + "static/media/PM.dc3a7168.svg";